import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Row } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'
import { useSlsHighlightsContext } from '@fs/zion-sls'
import { useOverlayContext } from '../../../../../../shared/providers/overlayContextProvider/OverlayContext'
import { useR2DispatchContext } from '../../../../../providers/r2Provider/R2Context'

const SharedFieldFooter = ({ saving = false, topMostPanel, saveButtonRef }) => {
  const [t] = useTranslation()
  const { closeOverlay } = useOverlayContext()
  const r2Dispatch = useR2DispatchContext()
  const h = useSlsHighlightsContext()

  const isFirstStep = topMostPanel() === 'editSharedFieldPage1'

  const resetChanges = useCallback(() => {
    r2Dispatch({ type: 'REVERT_HIGHLIGHTS', value: {} }) // This resets the blue selection highlights on the image
    h.clearEdits() // Clear the edits from the highlights hook when the user goes back
    closeOverlay('editSharedFieldPage1')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [r2Dispatch, closeOverlay])

  return (
    <>
      {isFirstStep ? (
        <Row alignX="end" gutters="md">
          <Button data-testid="panel-back-button" emphasis="low" disabled={saving} onClick={resetChanges}>
            {t('edit-shared-field-footer.cancel', 'Cancel')}
          </Button>
          <Button
            data-testid="panel-forward-button"
            emphasis="high"
            disabled={saving}
            form="edit-shared-field"
            type="submit"
          >
            {t('edit-shared-field-footer.next', 'Next')}
          </Button>
        </Row>
      ) : (
        <Row alignX="end" gutters="md">
          <Button
            data-testid="panel-back-button"
            emphasis="low"
            type="submit"
            form=""
            onClick={() => {
              closeOverlay('editSharedFieldPage2')
            }}
            disabled={saving}
          >
            {t('edit-shared-field-footer.back', 'Back')}
          </Button>
          <Button
            data-testid="panel-forward-button"
            emphasis="high"
            disabled={saving}
            Icon={saving && NoticeLoading}
            form="edit-shared-field-page-2"
            type="submit"
            ref={saveButtonRef}
          >
            {t('edit-shared-field-footer.update', 'Update')}
          </Button>
        </Row>
      )}
    </>
  )
}

export default SharedFieldFooter
